import HighlightTitle from '../HighlightCard/HighlightTitle';
import { jsx as _jsx } from "react/jsx-runtime";
const OrderHighlightTitle = ({
  title
}) => {
  return /*#__PURE__*/_jsx(HighlightTitle, {
    title: title,
    i18nKey: "ordersHighlightCard.title"
  });
};
export default OrderHighlightTitle;